import {
    Box,
    Button,
    Grid,
    Typography,
} from "@mui/material";
import { useRouteError } from "react-router";

import { btnsNamesConstants, globalConstants, viewsConstants } from "@/constants";
import { baseTheme } from "@/theme";

export const ErrorView = () => {
    const error = useRouteError();

    return (
        <Grid
            alignItems="center"
            flexDirection="column"
            height="100vh"
            justifyContent="center"
            margin="auto"
            textAlign="center"
            width="90%"
            container
        >
            <Box>
                <Typography
                    color="primary"
                    component={globalConstants.h1}
                    variant="h5"
                    gutterBottom
                >
                    {viewsConstants.error.title}
                </Typography>
                <Typography
                    variant="body1"
                    gutterBottom
                >
                    {viewsConstants.error.description}
                </Typography>
                <Box
                    bgcolor={baseTheme.palette.grey[900]}
                    borderRadius={2}
                    boxShadow={baseTheme.shape.boxShadow2}
                    mb={4}
                    mt={4}
                    overflow="hidden"
                    p={0}
                    textAlign="left"
                    width="100%"
                >
                    <Box
                        bgcolor={baseTheme.palette.action.hover}
                        borderBottom="1px solid"
                        borderColor={baseTheme.palette.grey[800]}
                        display="flex"
                        justifyContent="space-between"
                        px={2}
                        py={1}
                    >
                        <Box
                            color={baseTheme.palette.grey[500]}
                            display="flex"
                            fontWeight="bold"
                            gap={1}
                            variant="caption"
                        >
                            <Typography
                                color="primary"
                                fontWeight="normal"
                            >
                                {viewsConstants.error.errorStatus}
                            </Typography>
                            {error?.status || viewsConstants.error.applicationError}
                        </Box>
                        {error?.statusText && (
                            <Typography
                                color="primary"
                                variant="caption"
                            >
                                {error?.statusText}
                            </Typography>
                        )}
                    </Box>
                    <Box
                        bgcolor={baseTheme.palette.grey[900]}
                        maxHeight="40vh"
                        overflow="auto"
                        p={2}
                    >
                        <Box
                            component="pre"
                            display="flex"
                            flexDirection="column"
                            fontFamily="'Fira Code', 'Roboto Mono', monospace"
                            gap={2}
                            margin={0}
                            sx={{ wordBreak: "break-all" }}
                            whiteSpace="pre-wrap"
                        >
                            <Typography
                                color={baseTheme.palette.grey[100]}
                                variant="caption"
                            >
                                {error?.message || viewsConstants.error.unexpectedErrorOccurred}
                            </Typography>
                            {error?.stack && (
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    gap={1}
                                >
                                    <Typography
                                        color={baseTheme.palette.grey[500]}
                                        variant="caption"
                                    >
                                        {viewsConstants.error.stackTrace}
                                    </Typography>
                                    <Typography
                                        color="error" // eslint-disable-line
                                        variant="caption"
                                    >
                                        {error?.stack}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box>
                <Button
                    size="large"
                    variant="contained"
                    onClick={() => window.location.reload()}
                >
                    {btnsNamesConstants.reload}
                </Button>
            </Box>
        </Grid>
    );
};
